export default "__VITE_ASSET__Cx4Z17sj__"